import { useEffect, useRef, useState } from "react";
import { Icon } from "../lib/Icon";

/**
 * Header work timer (§7.7). One running timer per employee. This is the UI;
 * the authoritative server-side start timestamp (Durable Object) lands in
 * Phase 5 so it survives reloads and devices. Rounds up to the whole minute.
 */
export function WorkTimer() {
  const [running, setRunning] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const startedRef = useRef<number | null>(null);

  useEffect(() => {
    if (!running) return;
    const t = setInterval(() => {
      const started = startedRef.current ?? Date.now();
      setSeconds(Math.floor((Date.now() - started) / 1000));
    }, 1000);
    return () => clearInterval(t);
  }, [running]);

  function toggle() {
    if (running) {
      setRunning(false);
      setSeconds(0);
      startedRef.current = null;
    } else {
      startedRef.current = Date.now();
      setRunning(true);
    }
  }

  const clock = `${String(Math.floor(seconds / 3600)).padStart(2, "0")}:${String(Math.floor((seconds % 3600) / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;

  return (
    <div
      title="Work timer · rounds up to the next whole minute when stopped"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 7,
        background: running ? "rgba(159,227,194,.18)" : "rgba(255,255,255,.12)",
        border: `1px solid ${running ? "rgba(159,227,194,.5)" : "rgba(255,255,255,.16)"}`,
        borderRadius: 7,
        padding: "4px 5px 4px 9px",
        color: "#fff",
        flex: "none",
      }}
    >
      <span style={{ width: 7, height: 7, borderRadius: "50%", background: running ? "#7fe3b0" : "rgba(255,255,255,.5)" }} />
      <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 13, fontWeight: 700, letterSpacing: ".3px" }}>{clock}</span>
      <button
        onClick={toggle}
        title={running ? "Stop timer" : "Start timer"}
        style={{
          width: 26,
          height: 26,
          borderRadius: 5,
          border: 0,
          background: running ? "#c0612f" : "rgba(255,255,255,.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        <Icon name={running ? "circle" : "play"} size={12} color="#fff" />
      </button>
    </div>
  );
}
